import { render, staticRenderFns } from "./AttachmentScheme.vue?vue&type=template&id=38bece18&scoped=true"
import script from "./AttachmentScheme.vue?vue&type=script&lang=js"
export * from "./AttachmentScheme.vue?vue&type=script&lang=js"
import style0 from "./AttachmentScheme.vue?vue&type=style&index=0&id=38bece18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bece18",
  null
  
)

export default component.exports